import React from 'react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { CalendarFilterIc, CalendarIcon } from '../../../../components/icons';

interface AddedCellProps {
  campaign: {
    created_at: string;
  };
}

const AddedCell: React.FC<AddedCellProps> = ({ campaign }) => {
  const { t, lang } = useTranslations();

  const formatTimeAgo = (dateString: string): string => {
    if (!dateString) return '';
    // Ensure the date is parsed as UTC if no timezone specified
    let date: Date;
    if (dateString.endsWith('Z') || dateString.includes('+') || dateString.includes('-', 10)) {
      date = new Date(dateString);
    } else {
      // Backend returns UTC without Z suffix, so add it
      date = new Date(dateString + 'Z');
    }
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (lang === 'ru') {
      if (diffInDays > 0) return `${diffInDays}д. ${diffInHours % 24}ч. назад`;
      if (diffInHours > 0) return `${diffInHours}ч. назад`;
      if (diffInMinutes > 0) return `${diffInMinutes}мин. назад`;
      return 'только что';
    }

    // English
    if (diffInDays > 0) return `${diffInDays}d. ${diffInHours % 24}h. ago`;
    if (diffInHours > 0) return `${diffInHours}h. ago`;
    if (diffInMinutes > 0) return `${diffInMinutes}min. ago`;
    return 'just now';
  };

  return (
    <div className="flex items-center gap-1">
      <CalendarIcon />
      <Typography variant="body3" className="text-auth-muted text-xs leading-4">
        {formatTimeAgo(campaign.created_at)}
      </Typography>
    </div>
  );
};

export default AddedCell;
